// extracted by mini-css-extract-plugin
export default {"buttonUp":"ButtonUp_buttonUp__Dl+lE","buttonUpActive":"ButtonUp_buttonUpActive__dhND8","buttonUpUnactive":"ButtonUp_buttonUpUnactive__tWelu"};